export const LEADERSHIP_CHAPTERS = [
  { id: 'approval-document', label: '批复文件影印件' },
  { id: 'beijing-journalism-association', label: '北京新闻学会成立大会' },
  { id: 'three-s-association', label: '“三 S”研究会成立大会' },
  { id: 'academy-leadership', label: '院领导到所会议与合影' },
  { id: 'academic-platform', label: '学术平台与调研指导' },
  { id: 'conference-forum-inspection', label: '发布会、论坛与纪检调研' },
  { id: 'cooperation-platform-research', label: '共建平台与宣传思想文化战线调研' }
];

const SECTION_DEFINITIONS = [
  {
    id: 'org-history',
    title: '机构与历史',
    items: [
      {
        id: 'leadership-care',
        label: '领导关怀',
        route: '/lanhu_jigouyulishi',
        children: LEADERSHIP_CHAPTERS.map((chapter) => ({
          id: chapter.id,
          label: chapter.label,
          route: {
            path: '/lanhu_xuenihongzhao',
            query: {
              item: 'leadership-care',
              subitem: chapter.id,
              chapter: chapter.id
            }
          }
        }))
      },
      {
        id: 'evolution-history',
        label: '建制沿革',
        route: {
          path: '/lanhu_jigouyulishi',
          query: { item: 'evolution-history', subitem: 'name-change' }
        },
        navigateOnClick: true,
        children: [
          { id: 'name-change', label: '名称变更', route: '/lanhu_mingchengbiangeng' },
          { id: 'office-location-change', label: '办公地点变更', route: '/lanhu_bangongdidianbiangeng' },
          { id: 'organization-setup', label: '机构设置', route: '/lanhu_jigoushezhi' }
        ]
      }
    ]
  },
  {
    id: 'discipline',
    title: '学科与科研',
    items: [
      {
        id: 'discipline-build',
        label: '学科建设',
        route: '/lanhu_xuekeyukeyan',
        children: [
          { id: 'academic-achievement', label: '学术成果掠影', route: '/lanhu_zhengwenyexueshuchengguo' },
          {
            id: 'research-awards',
            label: '新闻与传播研究所科研成果获奖情况',
            route: '/lanhu_keyanchengguohuojiang'
          },
          { id: 'communication-conference', label: '中国传播学大会', route: '/lanhu_zhongguochuanboxuedahui' },
          { id: 'audience-seminar', label: '受众研究学术研讨会', route: '/lanhu_shouzhongyanjiu' },
          {
            id: 'bluebook-seminar',
            label: '新媒体蓝皮书发布暨新媒体发展研讨会',
            route: '/lanhu_xinmeitilanpishu'
          },
          { id: 'history-youth-forum', label: '新闻史青年学者论坛', route: '/lanhu_xinwenshiqingnian' },
          { id: 'public-opinion-survey', label: '舆情调查', route: '/lanhu_yuqingdiaocha' },
          { id: 'domestic-academic', label: '国内学术交流', route: '/lanhu_guoneixueshujiaoliu' },
          { id: 'academic-salon', label: '学术沙龙活动', route: '/lanhu_xueshushalong' },
          { id: 'research-activity', label: '调研活动', route: '/lanhu_diaoyanhuodong' },
          { id: 'research-center', label: '研究中心活动', route: '/lanhu_yanjiuzhongxin' },
          { id: 'international-academic', label: '国际学术交流', route: '/lanhu_guojixueshujiaoliu' },
          { id: 'academic-evaluation', label: '学术评价', route: '/lanhu_xueshupingjia' }
        ]
      },
      {
        id: 'innovation-project',
        label: '创新工程',
        route: '/lanhu_chuangxingongcheng',
        navigateOnClick: true,
        children: [{ id: 'innovation-project-detail', label: '创新工程', route: '/lanhu_chuangxingongcheng' }]
      }
    ]
  },
  {
    id: 'education',
    title: '教育与人才',
    items: [
      {
        id: 'graduate-education',
        label: '研究生教育',
        route: '/lanhu_jiaoyuyurencai',
        children: [
          { id: 'graduate-education-overview', label: '研究生教育', route: '/lanhu_yanjiushengjiaoyu' },
          { id: 'thesis-defense', label: '论文答辩', route: '/lanhu_lunwendabian' },
          { id: 'appendix', label: '附录', route: '/lanhu_fulu' }
        ]
      }
    ]
  },
  {
    id: 'communication',
    title: '传播与平台',
    items: [
      {
        id: 'communication-platform',
        label: '传播平台',
        route: '/lanhu_chuanboyupingtai',
        children: [
          { id: 'news-communication-study', label: '《新闻与传播研究》', route: '/new/lanhu_xinwenyuchuanboyanjiu' },
          { id: 'china-news-yearbook', label: '《中国新闻年鉴》', route: '/new/lanhu_zhongguoxinwennianjian' },
          {
            id: 'china-comm-yearbook',
            label: '《中国新闻传播学年鉴》',
            route: '/new/lanhu_zhongguoxinwenchuanboxuenianjian'
          },
          { id: 'zhixuelihua', label: '《治学例话》系列', route: '/new/lanhu_zhixuelihuaxilie' },
          {
            id: 'news-comm-abstract',
            label: '《新闻学传播学文摘》',
            route: '/new/lanhu_xinwenxuechuanboxuewenzhai'
          },
          { id: 'news-comm-web', label: '新闻与传播研究网', route: '/new/lanhu_xinwenyuchuanboyanjiuwang' },
          {
            id: 'academic-frontier-wechat',
            label: '“新闻与传播学术前沿”微信公号',
            route: '/new/lanhu_xinwenyuchuanboxueshuqianyan'
          }
        ]
      }
    ]
  },
  {
    id: 'research-support',
    title: '科研保障',
    items: [
      {
        id: 'research-support',
        label: '科研保障',
        route: '/lanhu_keyanbaozhang',
        children: [
          { id: 'party-building-work', label: '党建工作', route: '/lanhu_dangjiangongzuo' },
          { id: 'administrative-management-work', label: '行政管理工作', route: '/lanhu_xingzhengguanligongzuo' },
          { id: 'retired-cadre-work', label: '离退休干部工作', route: '/lanhu_lituixiuganbugongzuo' },
          { id: 'collective-birthday', label: '集体过生日', route: '/lanhu_jitiguoshengri' },
          { id: 'staff-collective-activities', label: '职工集体活动', route: '/lanhu_zhigongjitihuodong' }
        ]
      }
    ]
  },
  {
    id: 'personnel-directory',
    title: '人事名录',
    items: [
      {
        id: 'former-directors',
        label: '历任所领导',
        route: '/lanhu_lirensuolingdao'
      },
      {
        id: 'institution-history',
        label: '机构历史沿革',
        route: '/lanhu_jigoulishiyange'
      },
      {
        id: 'staff-directory',
        label: '人员名录',
        route: '/lanhu_renshirenyuanminglu'
      }
    ]
  }
];

export function createSidebarSections(options = {}) {
  const { activeSectionId = '', activeItemId = '', activeSubItemId = '', primaryItemIds = [] } = options;

  return SECTION_DEFINITIONS.map((section) => ({
    id: section.id,
    title: section.title,
    defaultOpen: section.id === activeSectionId,
    items: section.items.map((item) => ({
      ...item,
      arrow: item.id === activeItemId || primaryItemIds.includes(item.id) ? 'primary' : 'secondary',
      children: (item.children || []).map((child) => ({
        ...child,
        isActive: item.id === activeItemId && child.id === activeSubItemId
      }))
    }))
  }));
}
